import { render } from "./create_case.vue?vue&type=template&id=4643e77e&scoped=true"
import script from "./create_case.vue?vue&type=script&lang=js"
export * from "./create_case.vue?vue&type=script&lang=js"

import "./create_case.vue?vue&type=style&index=0&id=4643e77e&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4643e77e"]])

export default __exports__